module.exports = __webpack_public_path__ + "img/logo_deal_stree_asia.1b3db81c.png";